import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { useAuth } from "../../auth/AuthContext";
import { db } from "../../configs/firebase";

export type AppRole = "guest" | "shop" | "admin" | "user";

export function useUserRole() {
  const { user } = useAuth();
  const [role, setRole] = useState<AppRole>("guest");
  const [loadingRole, setLoadingRole] = useState(true);

  useEffect(() => {
    const loadRole = async () => {
      if (!user?.uid) {
        setRole("guest");
        setLoadingRole(false);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          const data = snap.data();
          const firestoreRole = String(data?.role || "guest").toLowerCase();

          // normalize
          if (firestoreRole === "shop") setRole("shop");
          else if (firestoreRole === "admin") setRole("admin");
          else if (firestoreRole === "guest") setRole("guest");
          else setRole("user");
        } else {
          setRole("guest");
        }
      } catch (e) {
        console.error("Failed to fetch role", e);
        setRole("guest");
      } finally {
        setLoadingRole(false);
      }
    };

    loadRole();
  }, [user?.uid]);

  return { role, loadingRole };
}
